module.exports = __webpack_public_path__ + "media/images/magic_modules/homepage_grid_module/hgm_pattern-2-bac0656b5200d325d7e57e80af53dca8.png";